import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './pacman.css';

const Pacman = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Set canvas size
    canvas.width = Math.min(800, window.innerWidth - 40);
    canvas.height = Math.min(600, window.innerHeight - 200);
    
    let animationId;
    let pacmanX = 50;
    let pacmanY = canvas.height / 2;
    let mouthOpen = true;
    let frameCount = 0;
    
    // Dots array
    const dots = [];
    for (let i = 0; i < 20; i++) {
      dots.push({
        x: Math.random() * (canvas.width - 100) + 100,
        y: Math.random() * (canvas.height - 100) + 50,
        eaten: false
      });
    }
    
    const drawPacman = (x, y, mouthOpen) => {
      ctx.fillStyle = '#FFD700';
      ctx.beginPath();
      ctx.arc(x, y, 20, 0, 2 * Math.PI);
      ctx.fill();
      
      // Draw mouth
      if (mouthOpen) {
        ctx.fillStyle = '#000';
        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.arc(x, y, 20, 0.2 * Math.PI, 1.8 * Math.PI);
        ctx.closePath();
        ctx.fill();
      }
      
      // Draw eye
      ctx.fillStyle = '#000';
      ctx.beginPath();
      ctx.arc(x - 5, y - 8, 3, 0, 2 * Math.PI);
      ctx.fill();
    };
    
    const drawDots = () => {
      ctx.fillStyle = '#FFD700';
      dots.forEach(dot => {
        if (!dot.eaten) {
          ctx.beginPath();
          ctx.arc(dot.x, dot.y, 5, 0, 2 * Math.PI);
          ctx.fill();
        }
      });
    };
    
    const checkCollisions = () => {
      dots.forEach(dot => {
        if (!dot.eaten) {
          const distance = Math.sqrt(
            Math.pow(pacmanX - dot.x, 2) + Math.pow(pacmanY - dot.y, 2)
          );
          if (distance < 25) {
            dot.eaten = true;
          }
        }
      });
    };
    
    const animate = () => {
      // Clear canvas
      ctx.fillStyle = '#000';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      // Update pacman position
      pacmanX += 2;
      if (pacmanX > canvas.width + 30) {
        pacmanX = -30;
        pacmanY = Math.random() * (canvas.height - 100) + 50;
      }
      
      // Update mouth animation
      frameCount++;
      if (frameCount % 15 === 0) {
        mouthOpen = !mouthOpen;
      }
      
      // Check for collisions
      checkCollisions();
      
      // Draw everything
      drawDots();
      drawPacman(pacmanX, pacmanY, mouthOpen);
      
      // Respawn dots if all eaten
      const remainingDots = dots.filter(dot => !dot.eaten).length;
      if (remainingDots === 0) {
        dots.forEach(dot => {
          dot.eaten = false;
          dot.x = Math.random() * (canvas.width - 100) + 100;
          dot.y = Math.random() * (canvas.height - 100) + 50;
        });
      }
      
      animationId = requestAnimationFrame(animate);
    };
    
    animate();
    
    // Cleanup
    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };
  }, []);

  return (
    <div className="pacman-container">
      <div className="pacman-header">
        <h1>Pacman!</h1>
        <p>You found the hidden easter egg! Watch Pacman collect dots.</p>
        <Link to="/" className="back-button">← Back to Home</Link>
      </div>
      <div className="game-area">
        <canvas ref={canvasRef} className="pacman-canvas"></canvas>
      </div>
      <div className="game-info">
        <p>Pacman automatically moves and collects dots!</p>
        <p>This is a simple demonstration game.</p>
      </div>
    </div>
  );
};

export default Pacman;